import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { nonNegativeNumberValidation } from 'validators';
import { InfoIcon, TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import pluralize from '~/utils/pluralize';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function PreapprovedTextField(param) {
    let { suffix } = param;
    const { control, watch } = useFormContext();
    const [isFocused, setIsFocused] = useState(false);
    const [unitCap, unitName, pricing] = watch([
        'unitCap',
        'unitName',
        'pricing'
    ]);
    const { PREAPPROVED_AMOUNT_IMPROVMENTS = false } = useFeatureFlags();
    const { t: preapprovalTexts } = useLocaleKeys('billing.preapproval');
    const isInfoOpen = isFocused && !!unitCap && +unitCap === 0;
    const validate = (value)=>{
        if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
            if (!value || +value <= 0) return preapprovalTexts.validation.setCapPositive();
            return true;
        }
        return nonNegativeNumberValidation(preapprovalTexts.validation.setCapNonNegative())(value);
    };
    const getLabel = ()=>{
        if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
            return preapprovalTexts.amountLabel();
        }
        const unit = pricing === 'unit' ? pluralize(unitName) || preapprovalTexts.unitFallback.units() : pricing === 'hour' ? preapprovalTexts.unitFallback.hours() : '';
        return preapprovalTexts.amountLabelLegacy({
            unit
        });
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "unitCap",
        rules: {
            validate
        },
        render: (renderProps)=>{
            const _connectControllerToTextField = connectControllerToTextField(renderProps), { onBlur, onChange } = _connectControllerToTextField, rest = _object_without_properties(_connectControllerToTextField, [
                "onBlur",
                "onChange"
            ]);
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                collapseHelperText: false,
                style: {
                    width: '100%'
                },
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                testId: "sb-cap",
                label: getLabel(),
                onFocus: ()=>setIsFocused(true),
                onChange: (e)=>{
                    const trimmedValue = e.target.value.slice(0, 7);
                    onChange({
                        target: {
                            value: trimmedValue
                        }
                    });
                },
                onBlur: ()=>{
                    setIsFocused(false);
                    onBlur();
                }
            }, rest), {
                suffix: PREAPPROVED_AMOUNT_IMPROVMENTS ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: suffix && /*#__PURE__*/ _jsx("span", {
                        "data-testid": "sb-cap-suffix",
                        children: suffix
                    })
                }) : /*#__PURE__*/ _jsx(InfoIcon, {
                    forceOpen: isInfoOpen,
                    testId: "sb-cap-info",
                    info: /*#__PURE__*/ _jsx("div", {
                        "data-testid": "sb-cap-tooltip",
                        children: preapprovalTexts.tooltipLegacy()
                    })
                })
            }));
        }
    });
}
